import React, { Component } from "react";
import { Col, Card, Form, Icon } from "antd";

class NewCarInformation extends Component {
  render() {
    const { newCar, visibleModal, formatRupiah, edit } = this.props;
    return (
      <Col xs={24} md={12}>
        <Card title="New Car Information">
          <Form.Item label="Mobil">
            <span className="ant-form-text form-text-mod">
              {newCar ? newCar.carName : "N/A"}&nbsp;&nbsp;
              {edit ? (
                <Icon
                  type="edit"
                  style={{ color: "#287AE5" }}
                  onClick={() => visibleModal("New Car", true)}
                />
              ) : null}
            </span>
          </Form.Item>
          <Form.Item label="OTR">
            <span className="ant-form-text form-text-mod">
              {newCar ? formatRupiah(newCar.otr) : "N/A"}
            </span>
          </Form.Item>
        </Card>
      </Col>
    );
  }
}

export default NewCarInformation;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/NewCarInformation.js